
import { Button } from "@/components/ui/button"
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select"
import { Switch } from "@/components/ui/switch"
import { Textarea } from "@/components/ui/textarea"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import type { Database } from "@/integrations/supabase/types"

type ClientCategory = Database["public"]["Tables"]["client_categories"]["Row"]

interface CategoryFormProps {
  category?: ClientCategory
  formId: string
  onSave: () => void
}

export function CategoryForm({ category, formId, onSave }: CategoryFormProps) {
  return (
    <form id={formId} className="space-y-4">
      <div className="space-y-2">
        <Label htmlFor={`name-${formId}`}>Name</Label>
        <Input
          id={`name-${formId}`}
          name="name"
          defaultValue={category?.name}
        />
      </div>
      <div className="space-y-2">
        <Label htmlFor={`description-${formId}`}>Description</Label>
        <Textarea
          id={`description-${formId}`}
          name="description"
          rows={3}
          defaultValue={category?.description || ""}
        />
      </div>
      <div className="space-y-2">
        <Label htmlFor={`tier-${formId}`}>Subscription Tier</Label>
        <Select
          name="tier"
          defaultValue={category?.subscription_tier || "essentials"}
        >
          <SelectTrigger>
            <SelectValue placeholder="Select tier" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="essentials">Essentials</SelectItem>
            <SelectItem value="pro">Pro</SelectItem>
            <SelectItem value="elite">Elite</SelectItem>
          </SelectContent>
        </Select>
      </div>
      <div className="flex items-center space-x-2">
        <Switch 
          id={`active-${formId}`} 
          name="active" 
          defaultChecked={category?.active ?? true}
        />
        <Label htmlFor={`active-${formId}`}>Active</Label>
      </div>
      <Button
        type="button"
        onClick={onSave}
        className="w-full"
      >
        {category ? "Update Category" : "Save Category"}
      </Button>
    </form>
  )
}
